<template>
<section class="compare-time">
  <el-select
    v-model="query.granularity"
    size="small"
    style="width:75px;"
    @change="onDimensionChanged"
  >
    <el-option
      v-for="dateOption in dateOptions"
      :key="dateOption.value"
      :value="dateOption.value"
      :label="dateOption.label"
    />
  </el-select>

  <component
    v-if="currentDateOption.component"
    :is="currentDateOption.component"
    :query="query"
    @select-changed="onComponentSelectChanged"
  />

  <slot />
</section>
</template>

<script>
export default {
  name: 'CompareTime',
  props: {
    query: {
      required: true,
      type: Object
    },
    startDatePickerOptions: {
      required: true,
      type: Object
    },
    endDatePickerOptions: {
      required: true,
      type: Object
    },
    queryFlag: {
      required: true,
      type: Boolean
    }
  },
  computed: {
    dateOptions () {
      return [{
        value: 'day',
        label: '日',
        component: 'compare-time-day'
      }, {
        value: 'month',
        label: '月',
        component: 'compare-time-month'
      }, {
        value: 'quarter',
        label: '季度',
        component: 'compare-time-quarter'
      }, {
        value: 'half_year',
        label: '半年',
        component: 'compare-time-half-year'
      }, {
        value: 'year',
        label: '年度',
        component: 'compare-time-year-wrapper'
      }]
    },
    currentDateOption () {
      let {granularity} = this.query
      return this.dateOptions.find(dateOption => dateOption.value === granularity)
    }
  },
  methods: {
    onComponentSelectChanged (flag) {
      this.$emit('update:queryFlag', flag)
    },
    onDimensionChanged () {
      this.$emit('dimension-changed', this.currentDateOption)
    }
  }
}
</script>

<style lang="scss" scoped>
.compare-time {
  .date-range {
    display: inline-block;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Data/CompareTime/index.vue